import { createSlice } from '@reduxjs/toolkit';

import { RootState } from './store';
import { PersonalAreaState } from './types';
import { fetchCurrentYearUserCompensations } from '../services';

const initialState: PersonalAreaState = {
  currentYearCompensations: [],
  isCurrentYearLoading: false,
};

const personalAreaSlice = createSlice({
  name: 'personalArea',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCurrentYearUserCompensations.pending, (state) => {
        state.isCurrentYearLoading = true;
      })
      .addCase(fetchCurrentYearUserCompensations.fulfilled, (state, { payload }) => {
        state.currentYearCompensations = payload;
        state.isCurrentYearLoading = false;
      })
      .addCase(fetchCurrentYearUserCompensations.rejected, (state) => {
        state.isCurrentYearLoading = false;
      });
  },
});

export const { reducer: personalAreaReducer } = personalAreaSlice;

export const getCurrentYearCompensations = ({ personalArea }: RootState) => personalArea.currentYearCompensations;
export const getCurrentYearIsLoading = ({ personalArea }: RootState) => personalArea.isCurrentYearLoading;
